import loaderGif from "../../assets/images/loader.gif"

export const Loader = () => {
  return (
      <div className="loader">
          <img src={loaderGif} alt="loaderGif"/>
      </div>
  )
}